import React from "react";
import PropTypes from "prop-types";
import {
  COMPANY_STATUSES,
  NO_BIZ,
  ACTIVE,
  OBSOLETE,
  OUT_OF_BIZ,
  CREDIT_HOLD
} from "MODULES/companies/constants";

const STATUS_LABELS = {
  [NO_BIZ]: {
    css: "text-danger",
    icon: "fa-warning",
    text: COMPANY_STATUSES[NO_BIZ].label
  },
  [ACTIVE]: {
    css: "text-success",
    icon: "fa-check",
    text: COMPANY_STATUSES[ACTIVE].label
  },
  [OBSOLETE]: {
    css: "text-default",
    icon: "fa-minus-circle",
    text: COMPANY_STATUSES[OBSOLETE].label
  },
  [OUT_OF_BIZ]: {
    css: "text-default",
    icon: "fa-minus-circle",
    text: COMPANY_STATUSES[OUT_OF_BIZ].label
  },
  [CREDIT_HOLD]: {
    css: "text-danger",
    icon: "fa-warning",
    text: COMPANY_STATUSES[CREDIT_HOLD].label
  }
};

export default function Status({ status }) {
  const info = STATUS_LABELS[status];
  if (!info) {
    return <span>{status}</span>;
  }

  return (
    <span className={`${info.css}`}>
      <i className={`fa ${info.icon}`} />
      &nbsp;&nbsp;{info.text}
    </span>
  );
}

Status.propTypes = {
  status: PropTypes.oneOf(Object.keys(COMPANY_STATUSES)).isRequired
};



// WEBPACK FOOTER //
// ./app/modules/companies/components/Detail/Status.jsx